import { valueOf } from "@/types/common";

export const USER_TYPE = {
  ADMIN: "admin",
  USER: "user",
};

export type TUserType = valueOf<typeof USER_TYPE>;

export const ADMIN_ROLE = {
  MANAGER: "manager",
  SALE: "company_sale",
  CUSTOM_SERVICE: "custom_service",
  AUDITOR: "auditor",
};

export type TAdminRole = valueOf<typeof ADMIN_ROLE>;

export enum ERSOContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}

export type TRSOContractStatus = valueOf<typeof ERSOContractStatus>;

export const RESIDENCE_STATUS = {
  SPECIFIED_SKILL_NO1: 1,
  SPECIFIED_SKILL_NO2: 2,
  SPECIFIED_ACTIVITY: 3,
} as const;

export enum ESpecificSkillCertificateType {
  SPECIFIED_SKILL_NO1 = "1号",
  SPECIFIED_SKILL_NO2 = "2号",
}

export const SPECIFIC_SKILL_CERTIFICATE_TYPE = {
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO1]: "1号",
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO2]: "2号",
} as const;

export const LANGUAGE_CODE = {
  VI: "vi",
  MY: "my",
  ID: "id",
  EN: "en",
};

export type TLanguageCode = valueOf<typeof LANGUAGE_CODE>;

export enum EIndustryExamType {
  PAPER_TEST = "paper_test",
  CBT = "cbt",
}

export type TIndustryExamType = valueOf<typeof EIndustryExamType>;

export enum EOrganizationContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}

export type TOrganizationContractStatus = valueOf<typeof EOrganizationContractStatus>;

export enum EOrganizationUserRole {
  ADMIN = "admin",
  GENERAL = "general",
}

export type TOrganizationUserRole = valueOf<typeof EOrganizationUserRole>;

export enum EOrganizationType {
  RSO = "rso",
  COMPANY = "company",
  OTHER = "other",
}

/** 課税区分 */
export const TAX_CATEGORY = {
  TAXABLE: "taxable",
  NON_TAXABLE: "non_taxable",
  OUT_OF_SCOPE: "out_of_scope",
  TAX_EXEMPT: "tax_exempt",
} as const;

export type TTaxCategory = valueOf<typeof TAX_CATEGORY>;

/** 請求書表示形式 */
export const INVOICE_DISPLAY_FORMAT = {
  AGGREGATED: "aggregated",
  ITEMIZED_PER_ORDER: "itemized_per_order",
} as const;

export type TInvoiceDisplayFormat = valueOf<typeof INVOICE_DISPLAY_FORMAT>;

/** 請求サイクル */
export const BILLING_CYCLE = {
  SPOT: "spot",
  RECURRING: "recurring",
} as const;

export type TBillingCycle = valueOf<typeof BILLING_CYCLE>;
